import React, { FunctionComponent, useEffect } from 'react'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableBody from '@material-ui/core/TableBody'
import { useSpecialRates } from '../SpecialRatesProvider'
import { formatTimestamp } from 'utils'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'react-i18next'
import ListNoRecords from 'Elements/ListNoRecords'
import { useClasses } from 'components/views/subscriptions/special-rates/SpecialRates.css'
import ListLoadingIndicator from 'Elements/ListLoadingIndicator'
import ListSkeleton from 'Elements/ListSkeleton'

export type Props = {}
export type Functions = {}
export type AllProps = Props & Functions

const List: FunctionComponent<AllProps> = ({}) => {
  const { t } = useTranslation()
  const classes = useClasses()
  const { rates, loadRates, listLoading } = useSpecialRates()

  useEffect(() => {
    loadRates()
  }, [])

  const showAssignedByColumn = rates && rates.find(session => {
    return typeof session.assigned_user_name !== 'undefined'
  })

  return (
    <>
      <Typography variant="h5" component="h1" className={classes.listTitle}>
        {t('specialRates.todayAssignedRates')}
      </Typography>

      {!rates && (
        <ListSkeleton />
      )}

      {rates && listLoading && (
        <ListLoadingIndicator />
      )}

      {rates && !rates.length && (
        <ListNoRecords />
      )}

      {rates && Boolean(rates.length) && (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('zone')}</TableCell>
                <TableCell>{t('period')}</TableCell>
                <TableCell>{t('plateNumber')}</TableCell>
                <TableCell>{t('droveIn')}</TableCell>
                {showAssignedByColumn && (
                  <TableCell>{t('assignedBy')}</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {rates.map((rate, key) => (
                <TableRow key={key}>
                  <TableCell>{rate.zone}</TableCell>
                  <TableCell>{rate.rate_name}</TableCell>
                  <TableCell style={{ fontFamily: '"Roboto Mono", monospace' }}>{rate.plate_number}</TableCell>
                  <TableCell>{formatTimestamp(rate.entry_time)}</TableCell>
                  {showAssignedByColumn && (
                    <TableCell>{rate.assigned_user_name}</TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  )
}

export default List
